const getComponentDisplayName = (Component) => (
  Component.displayName ||
  Component.name ||
  'Component'
)

export default getComponentDisplayName



// WEBPACK FOOTER //
// ./src/helpers/getComponentDisplayName.js